module.exports = __webpack_public_path__ + "static/img/biaodan.a6c9f72.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/biaodan.png
// module id = oNks
// module chunks = 1